import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setDispositionEquipmentClass, setPenaltyGlobalFlag, setDispositionPenaltyFee, setDispositionPenaltyFeeGridData, setDispositionType } from 'Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeAction';
import { GET_DISPOSITION_EQUIPMENT_CLASS, GET_PENALTY_GLOBAL_FLAG, GET_DISPOSITION_PENALTY_FEE, GET_DISPOSITION_PENALTY_FEE_GRID_DATA, GET_DISPOSITION_TYPE } from 'Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';

function* getDispositionPenaltyFeeSaga(assetList: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `orders/disposition/disposepenaltyfee`,
        payload: assetList?.assetDetailsForPenalty
    }
    try {
        yield put(globalLoaderText("Fetching Penalty Fee...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setDispositionPenaltyFee(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setDispositionPenaltyFee([]))
        yield put(globalLoaderText(""));
    }
}

function* getGlobalPenaltyFlag(): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `orders/dispositionflag`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching Penalty Fee Settings...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setPenaltyGlobalFlag(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setPenaltyGlobalFlag(false))
        yield put(globalLoaderText(""));
    }
}

function* getDispositionPenaltyFeeGridData(filterData: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `orders/grid/penaltyfee/report`,
        payload: filterData?.filterData
    }
    try {
        yield put(globalLoaderText("Fetching Penalty Fee Data...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setDispositionPenaltyFeeGridData(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setDispositionPenaltyFeeGridData([]))
        yield put(globalLoaderText(""));
    }
}

function* getDispositionEquipmentClass(): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `orders/grid/dropdown/equipmentclass`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setDispositionEquipmentClass(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setDispositionEquipmentClass([]))
        yield put(globalLoaderText(""));
    }
}

function* getDispositionType(): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `orders/grid/dropdown/dispositiontype`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setDispositionType(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setDispositionType([]))
        yield put(globalLoaderText(""));
    }
}

function* watchDispositionPenaltyFeeSync() {
    yield takeEvery(GET_DISPOSITION_PENALTY_FEE, getDispositionPenaltyFeeSaga);
    yield takeEvery(GET_PENALTY_GLOBAL_FLAG, getGlobalPenaltyFlag);
    yield takeEvery(GET_DISPOSITION_PENALTY_FEE_GRID_DATA, getDispositionPenaltyFeeGridData);
    yield takeEvery(GET_DISPOSITION_EQUIPMENT_CLASS, getDispositionEquipmentClass);
    yield takeEvery(GET_DISPOSITION_TYPE, getDispositionType);
}

export default function* combinedSaga() {
    yield all([
        watchDispositionPenaltyFeeSync()
    ])
}
